"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const faTimes_1 = require("@fortawesome/free-solid-svg-icons/faTimes");
function PutAway({ onClick, ariaLabel = 'dismiss' }) {
    const closeUsingKeyboard = react_1.default.useCallback((event) => {
        if ([' ', 'Escape', 'Enter'].includes(event.key)) {
            onClick();
            event.preventDefault();
            event.stopPropagation();
        }
    }, [onClick]);
    return (react_1.default.createElement("span", { className: 'put-away', "aria-label": ariaLabel, role: 'button', onClick: onClick, tabIndex: 0, onKeyDown: closeUsingKeyboard, "data-nudge-action": 'dismissed' },
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faTimes_1.faTimes })));
}
exports.default = PutAway;
